/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: disposition.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  GetDispositionsByAgentIdRequest,
  GetDispositionsByAgentIdResponse,
} from '../types/disposition';

export const createDispositionService = (transport: Transport) => ({
  async getDispositionsByAgentId(
    request: GetDispositionsByAgentIdRequest,
    options: RequestOptions = {},
  ): Promise<GetDispositionsByAgentIdResponse> {
    const url = getApiPath(API_METHODS.DispositionService.GetDispositionsByAgentId);
    return transport.get<GetDispositionsByAgentIdResponse>(url, { params: request, ...options });
  },
});

export type DispositionService = ReturnType<typeof createDispositionService>;
